import { render, staticRenderFns } from "./AiPromptChat.vue?vue&type=template&id=07c97889&scoped=true"
import script from "./AiPromptChat.vue?vue&type=script&lang=js"
export * from "./AiPromptChat.vue?vue&type=script&lang=js"
import style0 from "./AiPromptChat.vue?vue&type=style&index=0&id=07c97889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c97889",
  null
  
)

export default component.exports